import _ from "lodash";
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { EmptyState } from "@toddle-edu/ds-web";
import {
  NoMessagesIllustration,
  NoFilterResultIllustration,
  NoSearchInFilterIllustration,
} from "@toddle-edu/ds-theme";

import { useI18n } from "Hooks";
import { CHANNEL_TYPES, sortChannelTypes } from "MessagingV2/modules/Utils";

import classes from "./EmptyChannelList.scss";

export const VARIANTS = {
  NO_FILTERS: "NO_FILTERS",
  APPLIED_FILTERS: "APPLIED_FILTERS",
  SEARCH: "SEARCH",
};

const ENTITY_LOCALE_MAP = {
  [CHANNEL_TYPES.CHANNEL_CUSTOM]: "common:custom_channel_lowercase_other",
  [CHANNEL_TYPES.CHANNEL_FAMILY]: "common:family_channel_lowercase_other",
  [CHANNEL_TYPES.CHANNEL_SYSTEM_MANAGED]:
    "common:class_channel_lowercase_other",
};

const EmptyChannelList = ({ variant, channelFilters, searchText }) => {
  const { t } = useI18n(["common"]);

  const sortedChannelFilters = useMemo(
    () => sortChannelTypes([...channelFilters]),
    [channelFilters]
  );

  const data = {
    [VARIANTS.NO_FILTERS]: {
      illustration: NoMessagesIllustration,
      title: t("common:no_channels_found"),
      subtitle: t("common:no_conversation_subtext"),
    },
    [VARIANTS.APPLIED_FILTERS]: {
      illustration: NoFilterResultIllustration,
      title: t("common:noResultHeading"),
      subtitle: t("common:no_conversation_in_label", {
        label: t("common:join_array_with_and", {
          array: _.map(sortedChannelFilters, channelType =>
            t(ENTITY_LOCALE_MAP[channelType])
          ),
        }),
      }),
    },
    [VARIANTS.SEARCH]: {
      illustration: NoSearchInFilterIllustration,
      title: t("common:noResultHeading"),
      subtitle: t("common:no_search_results_found_subtext_with_label_short", {
        label: searchText,
      }),
    },
  };

  return (
    <div className={classes.container}>
      <EmptyState
        size="small"
        {..._.get(data, variant, data[VARIANTS.NO_FILTERS])}
      />
    </div>
  );
};

EmptyChannelList.propTypes = {
  variant: PropTypes.oneOf(_.values(VARIANTS)).isRequired,
  // channelFilters is required if variant is APPLIED_FILTERS
  channelFilters: PropTypes.arrayOf(PropTypes.string),
  // searchText is required if variant is SEARCH
  searchText: PropTypes.string,
};

EmptyChannelList.defaultProps = {
  channelFilters: [],
  searchText: "",
};

export default EmptyChannelList;
